import React from 'react';
import { Avatar, withStyles } from '@material-ui/core';
import { colors } from '../../config/theme';

const styles = {
  avatar: {
    width: '85px',
    height: '85px',
    border: `4px solid ${colors.primary}`,
  },
};

export const UserAvatar = ({ src, name = '', classes }) => {
  return (
    <Avatar className={classes.avatar} src={src}>
      {name}
    </Avatar>
  );
};

export default withStyles(styles)(UserAvatar);
